/*付款审批 */
import { $http, buildHeaders } from "./index";

//#region 采购审批

//获取列表
export const meetingpurchasepaymentapply_page = (params) => {
  return $http.get("/admin/MeetingPurchasePaymentApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取待审批详情
export const meetingpurchasepaymentapply_detail = (id) => {
  return $http.get(
    "/admin/MeetingPurchasePaymentApply/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取已审批详情
export const meetingpurchasepaymentapply_search = (id) => {
  return $http.get(
    "/admin/MeetingPurchasePaymentApply/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//审批
export const meetingpurchasepaymentapply_approve = (data) => {
  return $http.post("/admin/MeetingPurchasePaymentApply/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion

//#region 无采购审批

//获取列表
export const supplierpaymentapply_page = (params) => {
  return $http.get("/admin/SupplierPaymentApply/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取待审批详情
export const supplierpaymentapply_detail = (id) => {
  return $http.get(
    "/admin/SupplierPaymentApply/read",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//获取已审批详情
export const supplierpaymentapply_search = (id) => {
  return $http.get(
    "/admin/SupplierPaymentApply/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//审批
export const supplierpaymentapply_approve = (data) => {
  return $http.post("/admin/SupplierPaymentApply/approve", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion


//#region 办公费用付款

//获取列表
export const officeExpensePay_page = (params) => {
  return $http.get("/admin/OfficeExpensePay/index", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取已审批详情
export const officeExpensePay_search = (id) => {
  return $http.get(
    "/admin/OfficeExpensePay/detail",
    { params: { id } },
    {
      headers: buildHeaders(3, "数据加载中，请稍后……"),
    },
  );
};

//确认付款
export const officeExpensePay_pay = (data) => {
  return $http.post("/admin/OfficeExpensePay/pay", data, {
    headers: buildHeaders(3, "正在提交数据，请稍后……"),
  });
};

//#endregion
